import type { ScanStat } from "@/content/scanStats";

/**
 * One reusable display for scan figures: large value, short label, and the
 * base it was measured on. Stacks on phones, sits in a row from sm: upward.
 */
export function StatRow({ stats }: { stats: ScanStat[] }) {
  if (!stats.length) return null;
  const cols = stats.length >= 3 ? "sm:grid-cols-3" : stats.length === 2 ? "sm:grid-cols-2" : "";
  return (
    <dl
      className={`grid grid-cols-1 gap-px ${cols}`}
      style={{ background: "rgba(0,47,167,0.12)", border: "1px solid rgba(0,47,167,0.12)", margin: 0 }}
    >
      {stats.map((s) => (
        <div key={s.label} className="flex flex-col" style={{ background: "#fbfaf6", padding: "24px 24px 22px" }}>
          <dd
            style={{
              order: 1,
              margin: 0,
              fontFamily: '"IBM Plex Sans", "IBM Plex Sans Fallback", sans-serif',
              fontWeight: 300,
              fontSize: "clamp(40px, 4.4vw, 56px)",
              lineHeight: 1,
              letterSpacing: "-0.02em",
              color: "#002FA7",
            }}
          >
            {s.value}
          </dd>
          <dt
            style={{ order: 2, marginTop: 12, fontSize: 15, lineHeight: 1.45, color: "rgba(0,47,167,0.85)" }}
          >
            {s.label}
          </dt>
          <dd
            className="mono"
            style={{
              order: 3,
              margin: "14px 0 0",
              fontSize: 11,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "#8a6f3f",
            }}
          >
            {s.base}
          </dd>
        </div>
      ))}
    </dl>
  );
}
